import { ReactComponent as settingUnselectedIcon } from '../assets/images/sidebar/settingUnselectedIcon.svg';
import { ReactComponent as settingSelectedIcon } from '../assets/images/sidebar/settingSelectedIcon.svg';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const GroupListMenu = {
    id: 'group-list',
    title: 'System Setup',
    type: 'item',
    name: 'group',
    url: '/group/group-list',
    icon: settingUnselectedIcon, // icons.CheckCircleOutlineIcon,
    selected_icon: settingSelectedIcon, //icons.CheckCircleOutlineIcon,
    breadcrumbs: false
};

export default GroupListMenu;
